import DesignTokens from '@tableau/design-tokens';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { applyColor }from '~src/style/ColorService';

import { cssClass } from '../../style';

const cssPrefix = 'LicenseTabe';

export namespace LicenseTabStyle {
  export const licenseInfo = cssClass(cssPrefix, 'info', {
    marginRight:  '75px',
  });

  export const headerLine = cssClass(cssPrefix, 'header', {
    height: CommonStyles.Sizes.DataGridHeaderHeight,
    borderTop: `1px solid ${applyColor(DesignTokens.color.elevation.border.default.subtle, CommonStyles.Colors.DividerLineColor)}`,
    borderBottom: `1px solid ${applyColor(DesignTokens.color.elevation.border.default.subtle, CommonStyles.Colors.DividerLineColor)}`,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    backgroundColor: applyColor(DesignTokens.color.elevation.surface.default.default, CommonStyles.Colors.White),
    verticalAlign: 'top',
  });

  export const headerNumberic = cssClass(cssPrefix, 'number', {
    textAlign : 'right',
  });

  export const headerIcon = cssClass(cssPrefix, 'icon', {
    textAlign: 'center',
  });

  export const settingContainer = cssClass(cssPrefix, 'container', {
    marginLeft: '85px',
    width: '508px',
  });

}